module.exports = __webpack_public_path__ + "img/wechat.114eee9c.jpg";